import { ClientDetails } from "@models/clients/clientDetailsModel";
import * as moment from "moment";

export class ClientDetailsService {
  static $inject = ['clientCRMRepo'];

  constructor(private clientCRMRepo: any) { }

  // Add your service methods here
  public getFormattedDate(dateString: string): string {
        if (!dateString) return '';
        return moment(dateString).format('YYYY-MM-DD');
    }

    public getDateObject(dateString: string): Date | null {
        if (!dateString) return null;
        return moment(this.getFormattedDate(dateString)).toDate();
    }

    public getStringFromDate(date: Date | null): string {
        if (!date) return '';
        return moment(date).format('YYYY-MM-DD');
    }

    // private formatClientDates(): void {
    //     if (!this.client) return;
        
    //     // Convert nextReviewDate to Date object for HTML date input
    //     if (this.client.nextReviewDate) {
    //         this.client.nextReviewDate = this.getDateObject(this.client.nextReviewDate);
    //     }
    // }

    // Convenience methods for checking client types (can be used with null/undefined clients)
    public isIndividual(client: ClientDetails): boolean {
        if (!client) return false;
        return client.clientType === 'Individual';
    }

    public isInstitution(client: ClientDetails): boolean {
        if (!client) return false;
        return client.clientType === 'Institution';
    }

    // Signatory regime methods
    public saveSignatoryRegime(clientId: number, signatoryRegime: any) {
        return this.clientCRMRepo.saveSignatoryRegime(clientId, signatoryRegime);
    }

    public saveAuthorisedSignatory(signatoryRegimeId: number, authorisedSignatory: any) {
        return this.clientCRMRepo.saveAuthorisedSignatory(signatoryRegimeId, authorisedSignatory);
    }

    public saveBeneficiary(signatoryRegimeId: number, beneficiary: any) {
        return this.clientCRMRepo.saveBeneficiary(signatoryRegimeId, beneficiary);
    }

}



// WEBPACK FOOTER //
// ./src/services/clients/clients.details/clientdetails.service.ts